import PropTypes from "prop-types";
import { Input, Form } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const UserFirstName = ({ form, name, value, label, layout = "vertical" }) => {
    const [t] = useTranslation();

    return (
        <Form form={form} initialValues={{ [name]: value }} layout={layout}>
            <Form.Item
                name={name}
                label={t(label)}
                rules={[
                    {
                        required: true,
                        whitespace: true,
                        message: t("t_user_first_name_is_required")
                    }
                ]}
            >
                <Input placeholder={t("t_user_first_name")} style={{ width: "100%" }} />
            </Form.Item>
        </Form>
    );
};

UserFirstName.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string
};

export default UserFirstName;
